import AppRecord from './AppRecord.js'
import APP from '../../../main.js'

class VehicleCostEstimate extends AppRecord {
  get issue(){
    return this.constructor.employeeStore.issues.find(iss => iss.id === this.issue_id)
  }
  get issue_name(){
    return (this.issue || {}).name
  }
}
export default VehicleCostEstimate
